module.exports = __webpack_public_path__ + "img/ic_recommendation.1949a712.svg";